import CustomButton from '../../../components/CustomButton';
import useAdminButton from '../hooks/useAdminButton';

/** A filled CustomButton in the dashboard's colours (useAdminButton). */
const AdminButton = (props) => {
  const { color, textColor } = useAdminButton();

  return <CustomButton color={color} textColor={textColor} {...props} />;
};

export default AdminButton;
